import React from 'react'
// hooks
import { useApolloClient } from 'hooks/useApolloClient'
//static
import NumberIcon from '@mui/icons-material/Numbers'
// types
import { Widget } from 'store/reducers/dashboards'
import { FilterTarget, IFiltersQueryArgs, IFiltersResponse } from 'types/graphql'
// views
import { CardWrapper, CardTitle, CardValue } from './views'
// graphql
import { RISK_VIEW_FILTERS_QUERY } from 'graphql/risk/queries'
// utils
import { get, isNumber } from 'lodash'

interface Props {
  data: Widget
}

const Card: React.FC<Props> = ({ data }) => {
  const { client } = useApolloClient()

  const { openInWindow, width, height, title, filterId, riskViewId, riskTemplateId } = data.item.settings

  const onCardClick = async () => {
    if (filterId) {
      const filters = get(
        await client.query<IFiltersResponse, IFiltersQueryArgs>({
          query: RISK_VIEW_FILTERS_QUERY,
          variables: {
            filter: {
              targetId: riskTemplateId,
              target: FilterTarget.RiskTemplate
            }
          }
        }),
        'data.filters.data',
        []
      )

      const filter = filters.find((item) => item.id === filterId)

      if (filter) {
        const { fieldFilters, order } = filter.args

        localStorage.setItem('page', '0')
        localStorage.setItem('perPage', '10')
        localStorage.setItem('filterId', filterId)
        localStorage.setItem('riskView', riskViewId)
        localStorage.setItem('order', order ? JSON.stringify(order) : null)
        localStorage.setItem('filter', fieldFilters ? JSON.stringify(fieldFilters) : null)

        window.open('/forms', openInWindow ? '_blank' : '_self')
      }
    } else if (riskViewId) {
      localStorage.clear()
      localStorage.setItem('riskView', riskViewId)

      window.open('/forms', openInWindow ? '_blank' : '_self')
    }
  }

  const hasLink = !!filterId || !!riskViewId

  return (
    <CardWrapper hasLink={hasLink} width={width} height={height} onClick={onCardClick}>
      <CardTitle>{title || `< title >`}</CardTitle>
      {isNumber(data.data.risksCount) ? <CardValue>{data.data.risksCount}</CardValue> : <NumberIcon />}
    </CardWrapper>
  )
}

export default Card
